import { format, parseISO } from 'date-fns';

/**
 * Shared display formatters for read-only views (settings, stores,
 * carriers). Kept in `/lib` so feature slices reuse them without
 * cross-feature imports.
 */

/** ISO datetime → `d MMM yyyy` (e.g. `28 May 2026`); `—` when absent. */
export function formatDate(iso?: string): string {
  if (!iso) return '—';
  return format(parseISO(iso), 'd MMM yyyy');
}

/** A non-empty string, or an em-dash placeholder for empty/absent values. */
export function orDash(value?: string): string {
  return value && value.length > 0 ? value : '—';
}
